// extracted by mini-css-extract-plugin
export default {"wrapper":"VvmYj","content":"HiQcK","children":"XOtJl","fadeIn":"Oh6we","footer":"SWV9Y"};